import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./MainCRUD";
import { mainSlice } from "./MainSlice";

const { actions } = mainSlice;

export const updateGroupCredit = (balance) => (dispatch) => {
  dispatch(actions.groupCreditFetch({ data: balance, isBalanceOnly: true }));
};

export const callGroupCredit = (queryParams, isFastLink) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkGroupCredit(queryParams, isFastLink)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.groupCreditFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkGroupCredit");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchCashierAgentList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent21(queryParams, true)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierAgentListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCashierAgentList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const switchCashierAgent = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent21(queryParams, true)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierAgentSwitched());
          return response;
        }
      } else {
        throw new Error("Error api: switchCashierAgent");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
